// removed by extract-text-webpack-plugin
module.exports = {"link":"StyledLink__link___8pgHx","disabled":"StyledLink__disabled___1ZmX7"};